import React from 'react';
import SearchBox from '../containers/SearchBox';

import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import { trackLink } from '../../lib/analytics-helper';

const links = {
  community: Page.getCommunityLink(),
  resolutionCenter: i18n.link('smarthelp/links.heroLinks.resolutionCenter'),
};

const labels = {
  communitySmallScreen: i18n.message('smarthelp/heroSection.heroLinks.community.smallScreen'),
  communityLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.hcr.community.largeScreen'),

  resolutionSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.smallScreen'),
  resolutionLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.resolution.largeScreen'),

  emailSmallScreen: i18n.message('smarthelp/heroSection.heroLinks.email.smallScreen'),
  emailLargeScreen: i18n.message('smarthelp/heroSection.heroLinks.email.largeScreen'),
};

const HelpHeading = i18n.message('includes/common/quicknav.help_center');
const returnUri = encodeURIComponent(`${Page.getBaseUrl()}/smc/customer`);
const smcUrl = `/signin/?returnUri=${returnUri}`;
const isSmcEnabled = Page.getIsSmcEnabled();

const HeroSectionNoLink = () => {
  const FptiTracking = (fptiStr) => {
    trackLink({ id: 'hero', link: `smarthelp-hero-links-${fptiStr}` });
  };

  const getLabels = () => {
    if (links.community && links.resolutionCenter && isSmcEnabled && Page.isMobileLayout()) {
      return {
        community: labels.communitySmallScreen,
        resolution: labels.resolutionSmallScreen,
        message: labels.emailSmallScreen,
      };
    }
    return {
      community: labels.communityLargeScreen,
      resolution: labels.resolutionLargeScreen,
      message: labels.emailLargeScreen,
    };
  };
  const renderCommunity = () => {
    if (links.community) {
      return (
        <div className="community-link">
          <a
            className="community-text" target="_blank" rel="noopener noreferrer" href={links.community}
            onClick={() => FptiTracking('community')}
          >
            {getLabels().community}
            <div className="popup-icon" role="img" aria-label="Opens help center in a new window" />
          </a>
        </div>
      );
    }
    return null;
  };
  const renderMessageCenter = () => {
    if (isSmcEnabled) {
      return (
        <div className="message-link">
          <a
            className="message-text" target="_blank" rel="noopener noreferrer" href={smcUrl}
            onClick={() => FptiTracking('message')}
          >
            {getLabels().message}
            <div className="popup-icon" role="img" aria-label="Opens help center in a new window" />
          </a>
        </div>
      );
    }
    return null;
  };
  const renderResolutionCenter = () => {
    if (links.resolutionCenter) {
      return (
        <div className="resolution-link">
          <a
            className="resolution-text" target="_blank" rel="noopener noreferrer" href={links.resolutionCenter}
            onClick={() => FptiTracking('resolution')}
          >
            {getLabels().resolution}
            <div className="popup-icon" role="img" aria-label="Opens help center in a new window" />
          </a>
        </div>
      );
    }
    return null;
  };

  const renderHeroModule = () => (<div className="hero-selection-hcr">
    <div className="hero-selection-hcr-content">
      <h1 className="hero-selection-heading">{HelpHeading}</h1>
      <div className="search-box-container col-sm-12 col-md-6 col-lg-6">
        <SearchBox />
      </div>
      <div className="hero-selection-placeholder">
        <div className="hero-links">
          {renderCommunity()}
          {renderResolutionCenter()}
          {renderMessageCenter()}
        </div>
      </div>
    </div>
  </div>);
  return renderHeroModule();
};

export default HeroSectionNoLink;



// WEBPACK FOOTER //
// ./contactUs/components/HeroSectionNoLink.js